import OrderFinished from "../../../components/checkout/mainContentBox/OrderFinished";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {makeCartEmpty} from "../../../actions/cart";
import {
    clearOrderDetails,
    orderFinishCheckout, resetOrderState
} from "../../../actions/order";
import history from "../../../history";

const mapStateToProps = state => {
    return {
        paymentAuthorizationFailed: state.order.paymentAuthorizationFailed,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearOrderDetails: () => {
            dispatch(clearOrderDetails());
            dispatch(resetOrderState());
        },
        makeCartEmpty: () => dispatch(makeCartEmpty()),
        goToStartpage: () => {
            dispatch(orderFinishCheckout());
            history.pushHome();
        },
    };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderFinished));
